import {BaseStorageUtils} from "./base-storage-utils";

export class LocalStorageUtils extends BaseStorageUtils {
  static injectables = [];

  constructor() {
    super();

    this.storage = window.localStorage;
  }
}
